import { AppStore } from './../../core/state/app-store';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Location } from '../../models/location.model';

@Component({
  selector: 'app-map-location-card',
  templateUrl: './map-location-card.component.html',
  styleUrls: ['./map-location-card.component.scss'],
})
export class MapLocationCardComponent implements OnInit {
  @Input() id: number;
  location: Location;
  @Output() locationDeleted: EventEmitter<number> = new EventEmitter();
  constructor(private appStore: AppStore) {}

  ngOnInit() {
    this.location = this.appStore.getState().locations[this.id];
  }

  deleteLocation() {
    this.appStore.setState({
      ...this.appStore.getState(),
      locations: this.appStore
        .getState()
        .locations.filter((location, index) => index !== this.id),
    });
    this.locationDeleted.next(this.id);
  }
}
